import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => {
  const pageBackground = theme.palette.grey[400];
  const headerBorder = theme.palette.divider;
  const cellBase = {
    height: "52px !important",
    padding: "0 12px !important",
    boxSizing: "border-box" as const,
    borderTop: "none !important",
    borderLeft: "none !important",
    borderRight: "none !important",
    fontFamily: `${theme.typography.fontFamily} !important`,
    fontSize: `${theme.typography.body2.fontSize} !important`,
    lineHeight: `${theme.typography.body2.lineHeight} !important`,
    textAlign: "right !important" as "right",
  };

  return {
    root: {
      width: "100%",
      backgroundColor: pageBackground,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      border: "none",
      overflow: "visible",
      "& > .MuiPaper-root": {
        width: "100%",
        backgroundColor: "transparent",
        boxShadow: "none",
      },
      "& .MuiTableContainer-root": {
        width: "100%",
        overflow: "visible !important",
      },
      "& .MuiTable-root": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "separate",
        borderSpacing: 0,
        borderBottom: "none !important",
        backgroundColor: `${pageBackground} !important`,
      },
      "& .MuiTableCell-root": {
        whiteSpace: "nowrap",
        width: "33.33%",
      },
      "& .MuiTableHead-root": {
        borderTop: `1px solid ${headerBorder}`,
        borderBottom: `1px solid ${headerBorder}`,
        borderLeft: `1px solid ${headerBorder}`,
        borderRight: `1px solid ${headerBorder}`,
      },
      "& .MuiTableHead-root .MuiTableRow-root": {
        height: "52px !important",
        backgroundColor: `${pageBackground} !important`,
        borderTop: `1px solid ${headerBorder}`,
        borderBottom: `1px solid ${headerBorder}`,
      },
      "& .MuiTableHead-root .MuiTableCell-head, & [class*='cellHead'], & .MuiTableCell-stickyHeader": {
        ...cellBase,
        position: "sticky !important",
        top: "0 !important",
        zIndex: 5,
        borderTop: `1px solid ${headerBorder} !important`,
        borderBottom: `1px solid ${headerBorder} !important`,
        fontWeight: `${theme.typography.fontWeightMedium} !important`,
        backgroundColor: `${pageBackground} !important`,
        color: `${theme.palette.text.primary} !important`,
      },
      "& .MuiTableHead-root .MuiTableCell-head:first-of-type": {
        borderTopLeftRadius: 4,
        borderLeft: `1px solid ${headerBorder} !important`,
      },
      "& .MuiTableHead-root .MuiTableCell-head:last-of-type": {
        borderTopRightRadius: 4,
        borderRight: `1px solid ${headerBorder} !important`,
      },
      '&[dir="rtl"] .MuiTableHead-root .MuiTableCell-head:first-of-type, &[dir="rtl"] [class*="cellHead"]:first-of-type':
        {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 4,
          borderLeft: "none !important",
          borderRight: `1px solid ${headerBorder} !important`,
        },
      '&[dir="rtl"] .MuiTableHead-root .MuiTableCell-head:last-of-type, &[dir="rtl"] [class*="cellHead"]:last-of-type':
        {
          borderTopRightRadius: 0,
          borderTopLeftRadius: 4,
          borderRight: "none !important",
          borderLeft: `1px solid ${headerBorder} !important`,
        },
      "& .MuiTableBody-root .MuiTableRow-root": {
        height: "52px !important",
        backgroundColor: `${theme.palette.background.paper} !important`,
        "&:hover, &:hover .MuiTableCell-root": {
          backgroundColor: `${theme.palette.background.tableRowHover} !important`,
        },
      },
      "& .MuiTableBody-root .MuiTableCell-root": {
        ...cellBase,
        borderBottom: `1px solid ${headerBorder} !important`,
        fontWeight: `${theme.typography.fontWeightRegular} !important`,
        backgroundColor: `${theme.palette.background.paper} !important`,
        color: `${theme.palette.secondary.main} !important`,
      },
      "& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root, & .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root":
        {
          borderBottom: "none !important",
          borderBottomWidth: "0 !important",
        },
    },
    textCell: {
      display: "inline-flex",
      justifyContent: "flex-start",
      width: "100%",
    },
    tableScroll: {
      maxHeight: "calc(100vh - 200px)",
      overflowY: "auto",
      overflowX: "hidden",
      scrollbarWidth: "thin",
      scrollbarColor: `${theme.palette.divider} transparent`,
      "&::-webkit-scrollbar": {
        width: 6,
        display: "block",
      },
      "&::-webkit-scrollbar-track": {
        background: "transparent",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.divider,
        borderRadius: 10,
      },
    },
  };
});
